
import Select from 'react-select'
import React, { useEffect, useState } from 'react'

import PumpStationMasterPagePopup from './PumpStationMasterPagePopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { useSearchParams } from 'react-router-dom'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { WaterSupplyPumpStationExportTableDataAPI, WaterSupplyPumpStationMasterDeleteAPI, WaterSupplyPumpStationTableDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/WaterSupplyMasterSlice/WaterSupplyPumpStationSlice'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../Helper/Loading'
import { WaterSupplyPumpingStationDataDDL } from '../../../../../../Components/CommonDDL/WaterSupplyPumpingStationDDl'
import { PumpingStationMasterExportData } from './PumpStationMasterExportPage'
import { AstricSign } from '../../../../../../Helper/AstricSign'

export default function PumpingStationMasterPage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [PumpStationMasterPopupShow, setPumpStationMasterPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [FromTop, setFromTop] = useState(1)
    const [ToTop, setToTop] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)


    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WaterSupplyPumpingStation, setWaterSupplyPumpingStation] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setPumpStationMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setPumpStationMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setPumpStationMasterPopupShow(false)
    }


    const handleClear = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsClear(!IsClear)
        setWaterSupplyPumpingStation({
            ...WaterSupplyPumpingStation,
            ID: 0,
            Label: 'Select...',
        })
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsSearch(!isSearch)
    }

    useEffect(() => {
        const data = {
            M_WS_PumpStationID: WaterSupplyPumpingStation.ID,
            token: token,
            FromTop: FromTop,
            ToTop: ToTop,
            M_WardID: WardName.ID,
            PumpStation: '',
            M_UserID: 1,
            Flag: ApiFlag,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            handleWaterSupplyPumpStationExport:handleWaterSupplyPumpStationExport
        }
        if (WardName.ID != "0") {
            dispatch(WaterSupplyPumpStationTableDataAPI({ data }))
        }
    }, [IsPost, FromTop, isSearch, IsClear, WardName.ID])

    const { tableData, isLoading } = useSelector(state => state.WaterSupplyPumpStationTableData)

    const handleWaterSupplyPumpStationExport = () => {
        const data = {
            M_WS_PumpStationID: WaterSupplyPumpingStation.ID,
            token: token,
            FromTop: '1',
            ToTop: '99999',
            M_WardID: WardName.ID,
            PumpStation: '',
            M_UserID: 1,
            Flag: ApiFlag,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        if (WardName.ID != "0") {
            dispatch(WaterSupplyPumpStationExportTableDataAPI({ data }))
        }
    }
    // , [IsPost, isSearch, IsClear, WardName.ID])

    const { ExportTableData, isExportLoading } = useSelector(state => state.WaterSupplyPumpStationExportTableData)

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }


    const handleDeleteApi = (item) => {
        const data = {
            M_WS_PumpStationID: item.m_wS_PumpStationID,
            M_Distri_WS_PumpStationID: item.m_Distri_WS_PumpStationID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            DashProjectTypeId: DashProjectTypeId,
            RoleID:RoleID
        }
        dispatch(WaterSupplyPumpStationMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WaterSupplyPumpStationMasterDelete)

    useEffect(() => {
        setCurrentPage(0)
        // setFromTop(1)
        // setToTop(10)
    }, [WardName.ID, WaterSupplyPumpingStation.ID])


    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                DashboardName={DashboardName}
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-5'>
                                <h5 className="mt-2">Pumping Station</h5>
                            </div>
                            <div className='col-7 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <PumpingStationMasterExportData
                                                ExcelData={ExportTableData}
                                                name='Pumping Station'
                                                RoleID={RoleID}
                                            // searchName={searchName}
                                            />
                                    }
                                    <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-3 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}

                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-4">
                                                <WaterSupplyPumpingStationDataDDL
                                                    WaterSupplyPumpingStation={WaterSupplyPumpingStation}
                                                    setWaterSupplyPumpingStation={setWaterSupplyPumpingStation}
                                                    WardName={WardName}
                                                    // rowData={rowData}
                                                    DashProjectTypeId={DashProjectTypeId}
                                                />

                                            </div>


                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Ward Name</th>
                                                        <th>Pumping Station</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.wardName ? item.wardName : '-'}</td>
                                                                <td>{item.pumpStation ? item.pumpStation : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                            item={item}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) :
                                                            <td colSpan={15}>No data found</td>
                                                    }

                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFromTop}
                                                setTo={setToTop}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    PumpStationMasterPopupShow ?
                        <PumpStationMasterPagePopup
                            open={PumpStationMasterPopupShow}
                            // popupHeading="Pipe Line"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashProjectTypeId={DashProjectTypeId}
                            RoleID={RoleID}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}